import { getLogger } from "@goodgamestudios/logger";
import { Country } from "./goodgamestudios/countrydetection/impl/model/Country";
const logger = getLogger("Hacks.WorldAssignment.LanguageOverride");
/**
 * BUG HTML-5586:
 * when connection via hydra / customer support always display game in english (it would be hard for support agents if game is in chinese or greek or any language they dont know)
 *
 * WorldAssignmentFacade exposed to game is readonly.  Game should not mess around with DetectedCountry and Instance, this is why hack happens so deep in the initialization logic.
 * Forcing a ChangeLanguage had no effect because after all the logic checks what languages are available for the detected country, and if the choosen lang does not appears, change is ignored
 * overriding the value parsed from country.xml seems the only thing that allows us to show a different language, without screwing the WorldAssignment / ServerInstance logic.
 * since all properties in Country are read only, i am cloning the detectedCountry while overriding the LanguageCode property
 * @param country
 * @param isHydraLogin
 * @returns country
 */
export const forceEnglishForSupportAgents = (country: Country, isHydraLogin:boolean): Country => {
    if (!isHydraLogin) {
        return country
    }
    else {
        logger.warn(`SUK / HYDRA / COMMUNITY-SUPPORT LOGIN --> Overriding Language from ${country.ggsLanguageCode} to ENGLISH `);
        return Object.assign({}, country, {ggsLanguageCode: "en"});
    }
}
